import React, { useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import Loja from '~/components/Loja';
import { BuscaParceiro, InputText, InputMoney } from '~/components/NovosInputs';
import { SelectType } from '~/pages/DevolucaoESaidaNFDeFornecedor/protocols';
import { useAceiteDePagamento } from '../../hooks/useAceiteDePagamento';

export const SearchInputs: React.FC = () => {
  const {
    setLojas,
    lojas,
    isTitulos,
    register,
    control,
    setValue,
    clearErrors,
    errors,
  } = useAceiteDePagamento();

      useEffect(() => {
        setTimeout(() => {
          focusInputByName('pessoa')
        }, 50);
      }, [])
      
      const focusInputByName = (inputName: string) => {
        const inputElement = document.querySelector<HTMLInputElement>(
          `input[name="${inputName}"]`,
        );
        if (inputElement) {
          inputElement.click();
          inputElement.focus();
        }
      };
  


  return (
    <>
      <Row>
        <Col md={12} sm={12}>
          <Loja
            isMulti
            onChange={(val: number | number[]) => {
              setLojas(val);
            }}
            selectedLoja={lojas}
            isDisabled={isTitulos}
          />
        </Col>
      </Row>
      <Row>
        <Col md={8} sm={12} className="busca-parceiro">
          <BuscaParceiro
            name="pessoa"
            label="Parceiro *"
            placeholder="Informe pelo menos 3 caracteres do Cliente/Fornecedor/Loja/Transportadora"
            register={register}
            isError={errors.pessoa}
            disabled={isTitulos}
            control={control}
            customOptions={{
              buscarPor: {
                cliente: true,
                fornecedor: true,
                loja: true,
                transportadora: true,
              },
            }}
            changeSelected={(selected: SelectType) => {
              clearErrors('pessoa');
              setValue('pessoa', selected);
            }}
          />
        </Col>

        <Col md={2} sm={12}>
          <InputText
            label="Nº Docto"
            register={register}
            control={control}
            name="num_docto"
            disabled={isTitulos}
            placeholder="Informe o Nº Docto"
            maxLength={10}
            caseInput="upper"
            isError={!!errors.num_docto}
            onInput={(ev: any) => {
              const value = ev.target.value as string;
              const regexCaracteresEspeciais = /[!@#$^&*()_+{}[\]:;<>,.?~'-]/;
              if (
                regexCaracteresEspeciais.test(value) ||
                value.toString().includes('=')
              ) {
                return setValue('num_docto', '');
              }
              setValue('num_docto', value);
            }}
          />
        </Col>
        <Col md={2} sm={12}>
          <InputMoney
            label="Valor"
            name="val_parcela"
            placeholder="0,00"
            disabled={isTitulos}
            register={register}
            control={control}
            isError={errors.val_parcela}
            min={0.01}
          />
        </Col>
      </Row>
      <Row />
    </>
  );
};
